jQuery(function ($) {
  $('.news-weekly-recap__subscribe').on('click', function () {
    $('.news-weekly-recap__subscribe').toggleClass('news-weekly-recap__hidden');
    $('.news-weekly-recap__form').toggleClass('news-weekly-recap__hidden');
  });

  $('#mc-embedded-subscribe').on('click', function () {
    let intervalCount = 0;
    const interval = setInterval(function () {
      intervalCount += 1;
      if ($('#mce-success-response').html() === 'Thank you for subscribing!') {
        $('.mc-field-group').css('display', 'none');
        $('#mce-error-response').css('display', 'none');
        clearInterval(interval);
      } else if (intervalCount >= 50) {
        clearInterval(interval);
      }
    }, 100);
  });
});
